import { createSlice } from "@reduxjs/toolkit";

const initialCoinCategoriesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [],
  uploadimage: {},
  imageField: [],
  newCoinCategory: [],
  editCompany: {},
  deletedCompany: [],
  companyList: [],
  parentCompany: [],
  gameList: [],
  gameTypeList: [],
  countryList: [],
  countryDropdownList: [],
  currencyList: [],



};

export const callTypes = {
  list: "list",
  action: "action"
};

export const AddCompanyFormSlice = createSlice({

  name: "AddCompanyForm",
  initialState: initialCoinCategoriesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },

    CoinCategoriesList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    CoinCategoriesExport: (state, action) => {
      const { exportData } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.exportData = exportData;
    },
    uploadImage: (state, action) => {
      const { uploadimage, imageField } = action.payload;
      state.error = null;
      state.uploadimage = uploadimage;
      state.imageField = imageField;
    },
    createCoinCategory: (state, action) => {
      const { newCoinCategory } = action.payload;
      state.error = null;
      state.newCoinCategory = newCoinCategory;
    },
    updateCompany: (state, action) => {
      const { editCompany } = action.payload;
      state.error = null;
      state.editCompany = editCompany;
    },
    deleteCompany: (state, action) => {
      const { deletedCompany } = action.payload;
      state.error = null;
      state.deletedCompany = deletedCompany;
    },

    CompanyList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.companyList = entities.filter((a) => a.isShared === true);
      state.parentCompany = entities.filter((a) => a.isParent === true);
      // state.totalCount = totalCount;
    },

    gameList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.gameList = entities;
      // state.totalCount = totalCount;
    },
    gameTypeList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.gameTypeList = entities;
      // state.totalCount = totalCount;
    },
    countryList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.countryList = entities;
      // state.totalCount = totalCount;
    },

    countryDropdownList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.countryDropdownList = entities;
      // state.totalCount = totalCount;
    },


    singleItemFetched: (state, action) => {
      state.actionsLoading = false;
      state.editCompany = action.payload.editCompany;
      state.error = null;
    },

    currencyList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.currencyList = entities;
      // state.totalCount = totalCount;
    },

    currencyDropdownList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.currencyDropdownList = entities;
      // state.totalCount = totalCount;
    },
  }
});
